import React from 'react';
import { Award, Heart, TrendingUp, Users, BookOpen } from 'lucide-react';

const AboutUs = () => {
  return (
    <section id="about" className="py-24 bg-gradient-to-br from-[#1a1918] to-[#2d2826] relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 right-20 w-96 h-96 bg-[#6B3F3F] rounded-full blur-[150px]"></div>
        <div className="absolute bottom-20 left-20 w-96 h-96 bg-[#d4af37] rounded-full blur-[150px]"></div>
      </div>

      <div className="container mx-auto px-6 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            About Photo Booth Guru
          </h2>
          <div className="flex items-center justify-center space-x-3 mb-6">
            <div className="h-1 w-20 bg-gradient-to-r from-transparent to-[#d4af37]"></div>
            <img 
              src="/assets/images/logos/pbg-logo.png" 
              alt="PBG Logo" 
              className="h-12 w-12 object-contain"
            />
            <div className="h-1 w-20 bg-gradient-to-l from-transparent to-[#d4af37]"></div>
          </div>
          <div className="flex items-center justify-center space-x-3">
            <div className="flex items-center space-x-3 bg-white px-4 py-3 rounded-lg shadow-lg">
              <span className="text-lg text-[#1a1918] font-medium">From the house of</span>
              <img 
                src="/assets/images/logos/inkfly-logo.png" 
                alt="Inkfly Logo" 
                className="h-10 w-auto object-contain"
              />
            </div>
          </div>
        </div>

        <div className="grid lg:grid-cols-2 gap-16 items-center mb-16">
          {/* Story Section */}
          <div className="space-y-6">
            <div className="bg-white/5 backdrop-blur-sm border border-[#d4af37]/20 rounded-2xl p-8">
              <h3 className="text-3xl font-bold text-white mb-4">Our Story</h3>
              <p className="text-[#bbb5ae] leading-relaxed mb-4">
                With <span className="text-[#d4af37] font-semibold">13+ years of excellence</span> in the photo booth industry, Photo Booth Guru emerged from the legacy of <span className="text-white font-semibold">Inkfly Photo Booth</span> to bring unique, premium experiences to the Indian market.
              </p>
              <p className="text-[#bbb5ae] leading-relaxed mb-4">
                We specialize in <span className="text-white font-semibold">grandeur products</span> that are not available elsewhere in India, focusing on creating unforgettable moments at every event.
              </p>
              <p className="text-[#bbb5ae] leading-relaxed mb-4">
                Our commitment to <span className="text-[#d4af37] font-semibold">quality, innovation, and customer satisfaction</span> has made us industry leaders, trusted by thousands of clients across the country.
              </p>
              <p className="text-[#bbb5ae] leading-relaxed">
                Beyond products, we believe in <span className="text-[#d4af37] font-semibold">sharing knowledge and empowering others</span> with our 13+ years of experience through workshops and industry insights.
              </p>
            </div>
          </div>

          {/* Values Grid */}
          <div className="grid grid-cols-2 gap-6">
            <div className="bg-gradient-to-br from-[#d4af37]/10 to-transparent border border-[#d4af37]/30 rounded-xl p-6 hover-lift">
              <Award className="w-12 h-12 text-[#d4af37] mb-4" />
              <h4 className="text-xl font-bold text-white mb-2">Excellence</h4>
              <p className="text-[#bbb5ae] text-sm">
                13+ years of industry-leading expertise and innovation
              </p>
            </div>
            <div className="bg-gradient-to-br from-[#6B3F3F]/10 to-transparent border border-[#6B3F3F]/30 rounded-xl p-6 hover-lift">
              <Heart className="w-12 h-12 text-[#6B3F3F] mb-4" />
              <h4 className="text-xl font-bold text-white mb-2">Passion</h4>
              <p className="text-[#bbb5ae] text-sm">
                Dedicated to creating magical moments at every event
              </p>
            </div>
            <div className="bg-gradient-to-br from-[#d4af37]/10 to-transparent border border-[#d4af37]/30 rounded-xl p-6 hover-lift">
              <TrendingUp className="w-12 h-12 text-[#d4af37] mb-4" />
              <h4 className="text-xl font-bold text-white mb-2">Innovation</h4>
              <p className="text-[#bbb5ae] text-sm">
                20+ unique products unavailable elsewhere in Indian market
              </p>
            </div>
            <div className="bg-gradient-to-br from-[#6B3F3F]/10 to-transparent border border-[#6B3F3F]/30 rounded-xl p-6 hover-lift">
              <BookOpen className="w-12 h-12 text-[#6B3F3F] mb-4" />
              <h4 className="text-xl font-bold text-white mb-2">Knowledge</h4>
              <p className="text-[#bbb5ae] text-sm">
                Sharing our experience to empower others in the industry
              </p>
            </div>
          </div>
        </div>

        {/* Legacy Section */}
        <div className="bg-gradient-to-r from-[#6B3F3F]/20 to-[#d4af37]/20 border-2 border-[#6B3F3F]/30 rounded-2xl p-12 text-center">
          <div className="flex items-center justify-center space-x-4 mb-6">
            <img 
              src="/assets/images/logos/inkfly-logo.png" 
              alt="Inkfly Logo" 
              className="h-20 w-auto object-contain"
            />
            <div className="text-left">
              <h3 className="text-3xl font-bold text-white">The Inkfly Legacy</h3>
              <p className="text-[#d4af37]">13+ Years of Photo Booth Excellence</p>
            </div>
          </div>
          <p className="text-[#bbb5ae] text-lg max-w-3xl mx-auto leading-relaxed">
            Born from the prestigious <span className="text-white font-semibold">Inkfly Photo Booth</span> lineage, we carry forward a tradition of excellence, innovation, and unmatched service quality. Every product we offer is a testament to our commitment to bringing premium, grandeur experiences to events across India.
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;